import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storedJobPostingId: null,
  storedJobCode: null,
  aditionalState: null,
};

const SelectedJobPostingSlice = createSlice({
  name: "SelectedJobPosting",
  initialState,
  reducers: {
    setSelectedJobPosting: (state, action) => {
      if (action.payload?.storedJobPostingId) {
        return {
          ...initialState,
          ...action.payload,
        };
      }
      return {
        ...state,
        ...action.payload,
      };
    },
    resetSelectedJobPosting: () => initialState,
  },
});

export const { setSelectedJobPosting, resetSelectedJobPosting } =
  SelectedJobPostingSlice.actions;
export default SelectedJobPostingSlice.reducer;
